<template>
  <div>
    <v-container style="max-width: 1200px">
      <div
        style="
          border: 1px solid #d4d4d4;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          overflow: hidden;
        "
      >
        <v-toolbar flat color="#FFFFFF">
          <v-toolbar-title>Stats</v-toolbar-title>
        </v-toolbar>
        <div style="background-color: #ffffff">
          <v-row no-gutters>
            <v-col cols="10" class="d-flex">
              <StatsMainItem name="Views" :value="pageViewCount" />
              <StatsMainItem name="Visitors" :value="visitorCount" />
              <StatsMainItem name="Average visit time" value="100" />
            </v-col>
            <div class="col mr-4">
              <v-select
                dense
                outlined
                :items="dateRanges"
                v-model="selectedDateRange"
                item-value="value"
                item-text="name"
                @change="getData"
              ></v-select>
            </div>
          </v-row>
          <!-- <v-divider></v-divider>
          <v-row>
            <v-col cols="12">
              <StackedStatsChart
                v-if="!loading"
                :startDate="startDate"
                :endDate="endDate"
              />
            </v-col>
          </v-row> -->
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="6" style="border-right: 1px solid #cccccc">
              <StatsTable
                title="Pages"
                indicator="views"
                :data="stats.pageViews || []"
                nameProp="url"
              />
            </v-col>
            <v-col cols="6">
              <StatsTable
                title="Referrers"
                indicator="views"
                :data="getReferrersData"
                nameProp="referrer"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="4" style="border-right: 1px solid #cccccc">
              <StatsTable
                title="Browsers"
                indicator="visitors"
                :data="getBrowsersData"
                nameProp="browser"
              />
            </v-col>
            <v-col cols="4" style="border-right: 1px solid #cccccc">
              <StatsTable
                title="Operating systems"
                indicator="visitors"
                :data="stats.os || []"
                nameProp="os"
              />
            </v-col>
            <v-col cols="4">
              <StatsTable
                title="Devices"
                indicator="visitors"
                :data="stats.devices || []"
                nameProp="device"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="8" style="border-right: 1px solid #cccccc">
              <WorldMap :data="getCountriesData" v-if="!loading" />
            </v-col>
            <v-col cols="4">
              <StatsTable
                title="Countries"
                indicator="visitors"
                :data="getCountriesData"
                nameProp="country"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="5" style="border-right: 1px solid #cccccc">
              <StatsTable
                title="Events"
                indicator="count"
                :data="stats.events || []"
                nameProp="eventValue"
              />
            </v-col>
            <v-col cols="7"> Chart </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import StatsMainItem from "../../components/project/StatsMainItem";
import StatsTable from "../../components/project/StatsTable";
import WorldMap from "../../components/project/WorldMap";
// import StackedStatsChart from "../../components/project/StackedStatsChart";
import projectMixin from "../../components/project/project-mixin";
import { enUS } from "date-fns/locale";
import {
  subHours,
  subDays,
  startOfHour,
  startOfDay,
  startOfWeek,
  startOfMonth,
  startOfYear,
  endOfHour,
  endOfDay,
  endOfWeek,
  endOfMonth,
  endOfYear,
  differenceInMinutes,
  differenceInHours,
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInCalendarYears,
} from "date-fns";
import { BROWSERS } from "./stats";

const intl = new Intl.DisplayNames(["en"], { type: "region" });

const languages = {};

const getDateLocale = (locale) => {
  return languages[locale]?.dateLocale || enUS;
};

function getDateRange(value, locale = "en-US") {
  const now = new Date();
  const dateLocale = getDateLocale(locale);

  const match = value.match(
    /^(?<num>[0-9]+)(?<unit>hour|day|week|month|year)$/
  );

  if (!match) return;

  const { num, unit } = match.groups;

  if (+num === 1) {
    switch (unit) {
      case "day":
        return {
          startDate: startOfDay(now),
          endDate: endOfDay(now),
          unit: "hour",
          value,
        };
      case "week":
        return {
          startDate: startOfWeek(now, { locale: dateLocale }),
          endDate: endOfWeek(now, { locale: dateLocale }),
          unit: "day",
          value,
        };
      case "month":
        return {
          startDate: startOfMonth(now),
          endDate: endOfMonth(now),
          unit: "day",
          value,
        };
      case "year":
        return {
          startDate: startOfYear(now),
          endDate: endOfYear(now),
          unit: "month",
          value,
        };
    }
  }

  switch (unit) {
    case "day":
      return {
        startDate: subDays(startOfDay(now), num - 1),
        endDate: endOfDay(now),
        unit,
        value,
      };
    case "hour":
      return {
        startDate: subHours(startOfHour(now), num - 1),
        endDate: endOfHour(now),
        unit,
        value,
      };
  }
}

export default {
  mixins: [projectMixin],
  components: {
    StatsMainItem,
    StatsTable,
    WorldMap,
    // StackedStatsChart,
  },
  data() {
    return {
      loading: true,
      selectedDateRange: "24hour",
      startDate: "",
      endDate: "",
      dateRanges: [
        {
          name: "Last 24hr",
          value: "24hour",
        },
        {
          name: "Today",
          value: "1day",
        },
        {
          name: "This week",
          value: "1week",
        },
        {
          name: "This month",
          value: "1month",
        },
        {
          name: "Last 30 days",
          value: "30day",
        },
        {
          name: "Last 90 days",
          value: "90day",
        },
      ],
    };
  },
  computed: {
    pageViewCount() {
      return this.stats.stats ? this.stats.stats.pageviews.value : 0;
    },
    visitorCount() {
      return this.stats.stats ? this.stats.stats.uniques.value : 0;
    },
    getReferrersData() {
      return (this.stats.referrers || []).filter((r) => r.x);
    },
    getCountriesData() {
      return (this.stats.countries || [])
        .filter((r) => r.x)
        .map((r) => ({
          ...r,
          x: intl.of(r.x),
        }));
    },
    getBrowsersData() {
      return (this.stats.browsers || []).map((r) => ({
        ...r,
        x: BROWSERS[r.x] || r.x,
      }));
    },
  },
  methods: {
    async getData() {
      const { startDate, endDate, unit } = getDateRange(this.selectedDateRange);
      this.loading = true;
      await this.getWebsiteStats({ startDate, endDate });
      this.startDate = startDate;
      this.endDate = endDate;
      this.loading = false;

      const dateFuncs = {
        minute: [differenceInMinutes],
        hour: [differenceInHours],
        day: [differenceInCalendarDays],
        month: [differenceInCalendarMonths],
        year: [differenceInCalendarYears],
      };

      function getDateLength(startDate, endDate, unit) {
        const [diff] = dateFuncs[unit];
        return diff(endDate, startDate) + 1;
      }

      console.log(getDateLength(startDate, endDate, unit));
    },
  },
  async created() {
    await this.getData();
  },
};
</script>